import { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { HubspotBrochureDownload } from ".";
import CountUp from "react-countup";
import CountdownTimer from "../CountdownTimer";
import AOS from "aos";
import "aos/dist/aos.css";
import VisibilitySensor from "react-visibility-sensor";
import { useElementOnScreen } from "../../hooks/useElementOnScreen";
import GCWcarousel from "../GCWcarousel";
import Menubar from "../Menubar";
import GCWHubspot from "./GCWHubspot";
import Lazyload from "react-lazy-load";
import WellnessTracker from "./WellnessTracker";
import { Tooltip } from "reactstrap";

const GlobalWalkathonCampaign = (props) => {
    const [link, setlink] = useState("");
    const [showVideo, setshowVideo] = useState(false);

    const [containerRef, isVisible] = useElementOnScreen({
        root: null,
        threshold: 0,
        rootMargin: "0px",
    });

    const handleVideo = () => {
        setlink("https://www.youtube.com/embed/rwvAxTRM3XI");
        setshowVideo(true);
    };

    useEffect(() => {
        AOS.init({
            disable: "mobile",
            duration: 2000,
        });
    }, []);

    useEffect(() => {
        console.log("visible");
    }, [isVisible]);

    const [tooltipOpen, setTooltipOpen] = useState({
        tooltip1: false,
        tooltip2: false,
        tooltip3: false,
        tooltip4: false,
        tooltip5: false,
        tooltip6: false,
        tooltip7: false,
        tooltip8: false,
        tooltip9: false,
    });

    const toggleTooltip = (id) => {
        setTooltipOpen((prevState) => ({
            ...prevState,
            [id]: !prevState[id],
        }));
    };

    const closeAllTooltips = () => {
        setTooltipOpen({
            tooltip1: false,
            tooltip2: false,
            tooltip3: false,
            tooltip4: false,
            tooltip5: false,
            tooltip6: false,
        });
    };

    // console.log("abc");

    const items = [
        {
            title: "Exciting Perks and Lucrative Prizes",
            description: {
                __html: `Win exciting rewards upon completion and unlock exclusive discounts on Vantage Fit subscriptions.`,
            },
            imageSrc:
                "https://res.cloudinary.com/vantagecircle/image/upload/v1727692349/VantageFit/2024/gcw/GCW-Exciting_perks.png",
        },
        {
            title: "Exclusive Access to the Vantage Fit Corporate Wellness App",
            description: {
                __html: `Get full access to the Vantage Fit Mobile Application and its intuitive health-tracking features.`,
            },
            imageSrc:
                "https://res.cloudinary.com/vantagecircle/image/upload/v1727692350/VantageFit/2024/gcw/Exclusive_access_to_Vantage_fit.png",
        },
        {
            title: "Spice up your wellness program",
            description: {
                __html: `Break the monotony of your wellness program with engaging wellness challenges and activities.`,
            },
            imageSrc:
                "https://res.cloudinary.com/vantagecircle/image/upload/v1727692350/VantageFit/2024/gcw/Spice_up_your_wellness_program.png",
        },
        {
            title: "Compete against companies worldwide",
            description: {
                __html: `Battle it out for the top spot and earn your bragging rights against companies from around the world.`,
            },
            imageSrc:
                "https://res.cloudinary.com/vantagecircle/image/upload/v1727692349/VantageFit/2024/gcw/Compete_against_companies_worldwide.png",
        },
    ];

    return (
        <>
            <Menubar
                whatsInIt={"#whatsinit"}
                howToJoin={"#howtojoin"}
                joinNow={"#gcwHubspotForm"}
            />
            <section className="gcw-hero gcw-bg position-relative section-pdn-hero pt-8">
                <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block heroimg">
                    <div className="col-12 col-md-7">
                        <div className="col-12">
                            <div className="col-lg-5 px-0 pb-4">
                                <img
                                    className=""
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/e_trim/v1728279865/VantageFit/2024/gcw/walkathon_logo_2024-02.png"
                                    alt="GCW logo"
                                    width="300"
                                />
                                <div className="text-right gcwdate1 text-white">
                                    12<sup>th</sup> Nov - 10<sup>th</sup> Dec
                                </div>
                            </div>
                            {/* <div className="red-font homelabel">Employee Wellness Platform</div> */}

                            <h1 className="font-weight-semibold hero-heading pt-0 no-br">
                                Walk{" "}
                                <span className="herogreytxt">Together,</span>{" "}
                                <br />
                                Thrive{" "}
                                <span className="herogreytxt">Together</span>
                            </h1>
                            <p className="hero-para text-white no-br">
                                With three years of experience helping companies
                                boost employee wellness and team engagement,
                                Vantage Fit is back again with the fourth season
                                of the Global Corporate Virtual Walkathon.
                            </p>
                        </div>
                    </div>
                    <div className="col-md-5 ">
                        <div className="hero-right-img">
                            {/* <picture>
                                <source media="(max-width: 768px)" srcSet=""/>

                                <source srcSet=""/>

                                <img className="img-responsive" src="" alt="image 1"/>
                            </picture> */}
                        </div>
                    </div>
                </div>
                <div className="container custom_container">
                    <div className="col-12 gcwmv">
                        <div className="row d-flex">
                            <div className="col-12 gcwmv">
                                <div className="row regcounter">
                                    <div className="col-12  px-0">
                                        <div className="mb-2 text-white regtext text-center">
                                            Registration is closed
                                        </div>
                                        {/* <div className="pl-0 pr-0 col-12 mt-0 mt-sm-4 mtb25 mb-5 mb-lg-0 d-md-flex justify-content-md-center d-lg-flex justify-content-lg-start align-items-center">
                                            <a
                                                href="#gcwHubspotForm"
                                                className="vfitcompanycta arrowbtn-img"
                                            >
                                                Join the Virtual Walkathon
                                            </a>
                                        </div> */}
                                    </div>
                                    {/* <div className="col-12 col-md-5 gcwmv">
                                        <CountdownTimer />
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="position-relative pl-0 pr-0">
                <div className="sec_bg-color feat_box sect-white-col-2 shadow active_challenge features_0">
                    <div className="container custom_container d-flex flex-row-reverse m-d-block justify-content-center align-items-center">
                        <div className="col-12 col-md-6">
                            <div className="col-12">
                                <h2 className="font-weight-semibold section-heading">
                                    What happened in the previous seasons!
                                </h2>
                                <p className="section-para font-weight-normal">
                                    A global virtual walkathon aimed to help
                                    organizations get back on their feet and
                                    prioritize health and wellness in the years
                                    to come with a robust corporate fitness
                                    program.
                                </p>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 cta-img">
                            <div className="col-12 d-flex justify-content-center">
                                <img
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1690526789/VantageFit/gcw-2023/Teaser_thumbnail.png"
                                    loading="lazy"
                                    className={
                                        !showVideo
                                            ? `img-responsive d-flex mx-auto`
                                            : `d-none`
                                    }
                                    onClick={handleVideo}
                                    style={{
                                        borderRadius: "10px",
                                        border: "5px solid white",
                                        boxShadow:
                                            "1px 0px 19px rgba(0,0,0, 0.1)",
                                        cursor: "pointer",
                                    }}
                                    width="980"
                                    height="551"
                                />
                                <iframe
                                    loading="lazy"
                                    width="980"
                                    height="551"
                                    src={link}
                                    title="Make Every Step Count | Global Corporate Virtual Walkathon 2022 (Season 2) | Vantage Fit"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    className={
                                        showVideo
                                            ? `videoFrame d-flex`
                                            : `d-none`
                                    }
                                    style={{
                                        borderRadius: "10px",
                                        border: "5px solid white",
                                        boxShadow:
                                            "1px 0px 19px rgba(0,0,0, 0.1)",
                                        cursor: "pointer",
                                    }}
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="gcwfeat section-pdn gcwmilestone pb-5">
                <h2 className="section-heading text-center text-light">
                    Helping Organizations Inspire Wellness
                </h2>
                <p className="section-para font-weight-normal text-center text-white mt-3 px-3 px-lg-5 n-br">
                    Is your team struggling to stay active and connected in
                    today's hybrid work environment? With Vantage Fit, watch
                    your team feel energized, connected, <br />
                    and motivated. Our Global Virtual Walkathon has already
                    helped hundreds of teams break out of their sedentary
                    routines.
                </p>
                <div className="container mb-5">
                    <div className="col-12 col-md-10 offset-md-1 px-0">
                        <div className="row justify-content-center align-items-center">
                            <div className="col-12 col-md-1 d-flex justify-content-center align-items-center">
                                <div>
                                    <div className="orange-brd-ci"></div>
                                    <p className="font-weight-light mb-lg-0 text-white">
                                        2021
                                    </p>
                                </div>
                            </div>
                            <div className="col-12 col-md-2 px-0">
                                <div className="gcwsep"> --------------- </div>
                            </div>
                            <div className="col-12 col-md-1 d-flex justify-content-center align-items-center">
                                <div>
                                    <div className="orange-brd-ci"></div>
                                    <p className="font-weight-light mb-lg-0 text-white">
                                        2022
                                    </p>
                                </div>
                            </div>
                            <div className="col-12 col-md-2 px-0">
                                <div className="gcwsep"> --------------- </div>
                            </div>
                            <div className="col-12 col-md-1 d-flex justify-content-center align-items-center">
                                <div>
                                    <div className="orange-brd-ci"></div>
                                    <p className="font-weight-light mb-lg-0 text-white">
                                        2023
                                    </p>
                                </div>
                            </div>
                            <div className="col-12 col-md-2 px-0">
                                <div className="gcwsep"> --------------- </div>
                            </div>
                            <div className="col-12 col-md-1 d-flex justify-content-center align-items-center position-relative">
                                <div>
                                    <div className="orange-brd-ci orange-brd-ci1"></div>
                                    <img
                                        className="mapicon"
                                        src="https://res.cloudinary.com/vantagecircle/image/upload/v1728382103/VantageFit/2024/gcw/Location-gcw.svg"
                                        alt="mapicon"
                                    />
                                    <p className="font-weight-light mb-lg-0 text-white">
                                        2024
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="col-12 col-md-10 offset-md-1 px-0">
                        <div className="row">
                            <div className="col-6 col-sm-6 col-md-3 mb-3">
                                <div className="miles-sect">
                                    <div>
                                        <div className="mi-no">8100+</div>
                                        <div className="mi-txt">
                                            No. of Participants
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-3 mb-3">
                                <div className="miles-sect">
                                    <div>
                                        <div className="mi-no">30+</div>
                                        <div className="mi-txt">
                                            No. of Countries
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-3 mb-3">
                                <div className="miles-sect">
                                    <div>
                                        <div className="mi-no">$15k</div>
                                        <div className="mi-txt">
                                            Total Rewards Given
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-3 mb-3">
                                <div className="miles-sect">
                                    <div>
                                        <div className="mi-no">350M+</div>
                                        <div className="mi-txt">
                                            Total Steps Taken
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-3 mb-3">
                                <div className="miles-sect">
                                    <div>
                                        <div className="mi-no">250K+</div>
                                        <div className="mi-txt">
                                            Total Kms Covered
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-3 mb-3">
                                <div className="miles-sect">
                                    <div>
                                        <div className="mi-no">250+</div>
                                        <div className="mi-txt">
                                            Total Trees Planted
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-3 mb-3">
                                <div className="miles-sect">
                                    <div>
                                        <div className="mi-no">100+</div>
                                        <div className="mi-txt">
                                            No. of Companies
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-3 mb-3">
                                <div className="miles-sect">
                                    <div>
                                        <div className="mi-no">12M+</div>
                                        <div className="mi-txt">
                                            Total Calories Burned
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section
                id="whatsinit"
                name="whatsinit"
                className="gcwfeat home-bg-1 section-pdn"
            >
                <div className="section-heading text-center text-light">
                    Why participate?
                </div>
                <p className="section-para font-weight-normal text-center text-white mt-3 px-3 px-lg-5">
                    A simple virtual walkathon can boost morale, improve
                    physical health, and foster a sense of community within your
                    organization.
                </p>
                <WellnessTracker wellnessItems={items} />
                <p className="section-para font-weight-normal text-center text-white mt-5 px-3 px-lg-5">
                    Without initiatives like these, many employees may continue
                    to feel disengaged, isolated, and less productive.
                </p>
                {/* <div className="col-12 d-flex align-items-center justify-content-center">
                    <a
                        href="#gcwHubspotForm"
                        className="vfitcompanycta arrowbtn-img"
                    >
                        Register Now
                    </a>
                </div> */}
            </section>

            <section
                id="whatsinit"
                name="whatsinit"
                className="gcwfeat home-bg-1 position-relative about-pattern-vfit gcwplantype pt-5 pt-lg-0"
            >
                <div className="section-heading text-center text-light mb-5">
                    Registration Plans
                </div>
                <div className="container">
                    <div className="col-12 col-md-9 offset-md-1 px-0 mb-5">
                        <div className="row">
                            <div className="col-12 col-sm-6 mb-3">
                                <div className="plan-container free-type">
                                    <div className="plantype">Free</div>
                                    <ul className="mb-4">
                                        <li>25-100 Employees</li>
                                        <li>
                                            Full Access to the Vantage Fit App
                                            <div
                                                className="info-icon"
                                                id="tooltip7"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    toggleTooltip("tooltip7");
                                                }}
                                            >
                                                i
                                            </div>
                                            <Tooltip
                                                isOpen={tooltipOpen.tooltip7}
                                                toggle={() =>
                                                    toggleTooltip("tooltip7")
                                                }
                                                autohide={false}
                                                placement="top"
                                                target="tooltip7"
                                            >
                                                *Till the Vantage Fit Global
                                                Corporate virtual walkathon
                                                ends.
                                            </Tooltip>
                                        </li>
                                        <li>Certificates</li>
                                        <li style={{ opacity: "0" }}>
                                            Certificates
                                        </li>
                                    </ul>
                                    <div className="position-relative rbn-cont mb-4">
                                        <img
                                            className="rbn"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1728039061/VantageFit/2024/gcw/Exclusive_benefits_free.png"
                                            alt="exclusive benefits"
                                        />
                                        {/* <div>Exclusive Benefits</div> */}
                                    </div>
                                    <div className="text-lg-center">
                                        <p
                                            className="mb-1"
                                            style={{ fontWeight: "300" }}
                                        >
                                            <strong className="text-white">
                                                40% off
                                            </strong>
                                            &nbsp;on Annual Subscription
                                            <div
                                                className="info-icon"
                                                id="tooltip8"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    toggleTooltip("tooltip8");
                                                }}
                                            >
                                                i
                                            </div>
                                            <Tooltip
                                                isOpen={tooltipOpen.tooltip8}
                                                toggle={() =>
                                                    toggleTooltip("tooltip8")
                                                }
                                                autohide={false}
                                                placement="top"
                                                target="tooltip8"
                                            >
                                                *On subscription of the Vantage
                                                Fit Platform
                                            </Tooltip>
                                        </p>
                                        <p
                                            className="mb-1"
                                            style={{ fontWeight: "300" }}
                                        >
                                            <strong className="text-white">
                                                25% off
                                            </strong>
                                            &nbsp;on One-Time Subscription
                                            <div
                                                className="info-icon"
                                                id="tooltip9"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    toggleTooltip("tooltip9");
                                                }}
                                            >
                                                i
                                            </div>
                                            <Tooltip
                                                isOpen={tooltipOpen.tooltip9}
                                                toggle={() =>
                                                    toggleTooltip("tooltip9")
                                                }
                                                autohide={false}
                                                placement="top"
                                                target="tooltip9"
                                            >
                                                *Of the Vantage Fit Platform
                                            </Tooltip>
                                        </p>
                                        <p
                                            style={{ opacity: "0" }}
                                            className="mb-1"
                                        >
                                            Certificates
                                        </p>
                                        <p
                                            style={{ opacity: "0" }}
                                            className="mb-1"
                                        >
                                            Certificates
                                        </p>
                                    </div>
                                    {/* <div className="mtb25 d-flex justify-content-center align-items-center">
                                        <a
                                            href="#gcwHubspotForm"
                                            className="plantype-btn btn-grey"
                                        >
                                            Register Now
                                        </a>
                                    </div> */}
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 mb-3">
                                <div className="plan-container paid-type">
                                    <div className="plantype orange-font">
                                        Paid
                                    </div>
                                    <div onClick={closeAllTooltips}>
                                        <ul
                                            className="mb-4"
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <li>
                                                100-500 Employees
                                                <div
                                                    className="info-icon"
                                                    id="tooltip1"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        toggleTooltip(
                                                            "tooltip1"
                                                        );
                                                    }}
                                                >
                                                    i
                                                </div>
                                                <Tooltip
                                                    isOpen={
                                                        tooltipOpen.tooltip1
                                                    }
                                                    toggle={() =>
                                                        toggleTooltip(
                                                            "tooltip1"
                                                        )
                                                    }
                                                    autohide={false}
                                                    placement="top"
                                                    target="tooltip1"
                                                >
                                                    *Companies with more than
                                                    500 employees will be
                                                    charged on a pro-rata basis.
                                                </Tooltip>
                                            </li>
                                            <li>
                                                Full Access to the Vantage Fit
                                                App
                                                <div
                                                    className="info-icon"
                                                    id="tooltip2"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        toggleTooltip(
                                                            "tooltip2"
                                                        );
                                                    }}
                                                >
                                                    i
                                                </div>
                                                <Tooltip
                                                    isOpen={
                                                        tooltipOpen.tooltip2
                                                    }
                                                    toggle={() =>
                                                        toggleTooltip(
                                                            "tooltip2"
                                                        )
                                                    }
                                                    autohide={false}
                                                    placement="top"
                                                    target="tooltip2"
                                                >
                                                    *Till the Vantage Fit Global
                                                    Corporate virtual walkathon
                                                    ends.
                                                </Tooltip>
                                            </li>
                                            <li>
                                                Prizes for Top 3 Teams
                                                <div
                                                    className="info-icon"
                                                    id="tooltip3"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        toggleTooltip(
                                                            "tooltip3"
                                                        );
                                                    }}
                                                >
                                                    i
                                                </div>
                                                <Tooltip
                                                    isOpen={
                                                        tooltipOpen.tooltip3
                                                    }
                                                    toggle={() =>
                                                        toggleTooltip(
                                                            "tooltip3"
                                                        )
                                                    }
                                                    autohide={false}
                                                    placement="top"
                                                    target="tooltip3"
                                                >
                                                    *To be disclosed.
                                                </Tooltip>
                                            </li>
                                            <li>Certificates</li>
                                        </ul>
                                    </div>
                                    <div className="position-relative rbn-cont mb-4">
                                        <img
                                            className="rbn"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1728039061/VantageFit/2024/gcw/exclusive_benefits_banner.png"
                                            alt="exclusive benefits"
                                        />
                                        <img
                                            className="tagimg"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1727692348/VantageFit/2024/gcw/Tag.png"
                                            alt="tag"
                                        />
                                        {/* <div>Exclusive Benefits</div> */}
                                    </div>
                                    <div className="text-lg-center">
                                        {/* <p className="mb-1 orange-font position-relative"><span className="newamnt">$0.00</span></p> */}
                                        {/* <p className="mb-1 position-relative" style={{ fontWeight: '300' }}><span className="strikeimg"><img src="https://res.cloudinary.com/vantagecircle/image/upload/v1727764074/VantageFit/2024/gcw/Slash.svg" alt="strike"/></span><span className="text-white" style={{ color: '#cccccc!important' }}>$250</span> <span className="orange-font font-weight-bold">$0.00</span> Platform Setup Cost</p>
                                        <p className="mb-1" style={{ fontWeight: '300' }}><strong className="text-white">50% off</strong> on Annual Subscription</p>
                                        <p className="mb-1" style={{ fontWeight: '300' }}><strong className="text-white">30% off</strong> on One-Time Subscription</p>
                                        <p className="mb-1" style={{ fontWeight: '300' }}>Participation Engagement Report</p> */}
                                        <div onClick={closeAllTooltips}>
                                            <p
                                                className="mb-1 position-relative"
                                                style={{ fontWeight: "300" }}
                                            >
                                                <span className="strikeimg">
                                                    <img
                                                        src="https://res.cloudinary.com/vantagecircle/image/upload/v1727764074/VantageFit/2024/gcw/Slash.svg"
                                                        alt="strike"
                                                    />
                                                </span>
                                                <span
                                                    className="text-white"
                                                    style={{
                                                        color: "#cccccc!important",
                                                    }}
                                                >
                                                    $250
                                                </span>
                                                &nbsp;
                                                <span className="orange-font font-weight-bold">
                                                    $0.00
                                                </span>
                                                &nbsp;Platform Setup Cost
                                                <div
                                                    className="info-icon"
                                                    id="tooltip4"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        toggleTooltip(
                                                            "tooltip4"
                                                        );
                                                    }}
                                                >
                                                    i
                                                </div>
                                                <Tooltip
                                                    isOpen={
                                                        tooltipOpen.tooltip4
                                                    }
                                                    toggle={() =>
                                                        toggleTooltip(
                                                            "tooltip4"
                                                        )
                                                    }
                                                    autohide={false}
                                                    placement="top"
                                                    target="tooltip4"
                                                >
                                                    *On subscription of the
                                                    Vantage Fit Platform
                                                </Tooltip>
                                            </p>
                                            <p
                                                className="mb-1"
                                                style={{ fontWeight: "300" }}
                                            >
                                                <strong className="text-white">
                                                    50% off
                                                </strong>
                                                &nbsp;on Annual Subscription
                                                <div
                                                    className="info-icon"
                                                    id="tooltip5"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        toggleTooltip(
                                                            "tooltip5"
                                                        );
                                                    }}
                                                >
                                                    i
                                                </div>
                                                <Tooltip
                                                    isOpen={
                                                        tooltipOpen.tooltip5
                                                    }
                                                    toggle={() =>
                                                        toggleTooltip(
                                                            "tooltip5"
                                                        )
                                                    }
                                                    autohide={false}
                                                    placement="top"
                                                    target="tooltip5"
                                                >
                                                    *Of the Vantage Fit Platform
                                                </Tooltip>
                                            </p>
                                            <p
                                                className="mb-1"
                                                style={{ fontWeight: "300" }}
                                            >
                                                <strong className="text-white">
                                                    30% off
                                                </strong>
                                                &nbsp;on One-Time Subscription
                                                <div
                                                    className="info-icon"
                                                    id="tooltip6"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        toggleTooltip(
                                                            "tooltip6"
                                                        );
                                                    }}
                                                >
                                                    i
                                                </div>
                                                <Tooltip
                                                    isOpen={
                                                        tooltipOpen.tooltip6
                                                    }
                                                    toggle={() =>
                                                        toggleTooltip(
                                                            "tooltip6"
                                                        )
                                                    }
                                                    autohide={false}
                                                    placement="top"
                                                    target="tooltip6"
                                                >
                                                    *Of the Vantage Fit Platform
                                                </Tooltip>
                                            </p>
                                            <p
                                                className="mb-1"
                                                style={{ fontWeight: "300" }}
                                            >
                                                Participation Engagement Report
                                            </p>
                                        </div>
                                    </div>
                                    {/* <div className="mtb25 d-flex justify-content-center align-items-center">
                                        <a
                                            href="#gcwHubspotForm"
                                            className="plantype-btn btn-orange"
                                        >
                                            Register Now
                                        </a>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section
                id="gcwHubspotForm"
                name="gcwHubspotForm"
                className="gcw-formbg position-relative"
            >
                <div className="">
                    <div className="col-12 col-md-6 gcw-form-cont">
                        <div className="container">
                            <div className="padding-dem">
                                <h2 className="section-heading text-white mb-3">
                                    Register Your Team Now
                                </h2>
                                <HubspotBrochureDownload formID="7791aa6e-67f3-4e7c-b15e-cdc03d4288ce" />

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section
                id="howtojoin"
                name="howtojoin"
                className="section-pdn position-relative htj pt-5"
            >
                <div className="container custom_container">
                    <div className="col-12 logo-gcw-cont mb-5">
                        <h2 className="section-heading section-heading-top no-br mb-2 mt-0">
                            How it Works?
                        </h2>
                        <div
                            className="dash relative row d-flex align-items-start justify-content-center py-3 py-lg-5"
                            data-aos="fade-up"
                            data-aos-once="true"
                        >
                            <div className="col-12 col-lg-1 px-0 mx-auto text-center d-flex justify-content-center justify-content-lg-end">
                                <div className="steps-icon">
                                    <img
                                        src="https://res.cloudinary.com/vantagecircle/image/upload/v1727764073/VantageFit/2024/gcw/register.svg"
                                        alt="Register"
                                        width="64"
                                        height="65"
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-11 pt-2">
                                <h3 className="text-center text-lg-left py-2">
                                    Sign up for the virtual walkathon
                                </h3>
                                <p className="para text-center text-lg-left">
                                    Fill up the form on this page, select your
                                    plan, and submit. Our team will reach out to
                                    you with further instructions via mail and
                                    call.
                                </p>
                            </div>
                        </div>
                        <div
                            className="dash relative row d-flex align-items-start justify-content-center py-4 py-lg-5"
                            data-aos="fade-up"
                            data-aos-once="true"
                        >
                            <div className="col-12 col-lg-1 px-0 mx-auto text-center d-flex justify-content-center justify-content-lg-end">
                                <div className="steps-icon">
                                    <img
                                        className="mb-2 mb-lg-4"
                                        src="https://res.cloudinary.com/vantagecircle/image/upload/v1727764073/VantageFit/2024/gcw/Form_team.svg"
                                        alt="Form Your Team"
                                        width="64"
                                        height="65"
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-11 pt-2">
                                <h3 className="font-weight-bold text-center text-lg-left py-2">
                                    Form Your Teams
                                </h3>
                                <p className="para text-center text-lg-left">
                                    Submit the required team details in the form
                                    attached to the email we sent after
                                    registration acknowledgment.
                                </p>
                            </div>
                        </div>
                        <div
                            className="dash relative row d-flex align-items-start justify-content-center py-4 py-lg-5"
                            data-aos="fade-up"
                            data-aos-once="true"
                        >
                            <div className="col-12 col-lg-1 px-0 mx-auto text-center d-flex justify-content-center justify-content-lg-end">
                                <div className="steps-icon">
                                    <img
                                        className="mb-2 mb-lg-4"
                                        src="https://res.cloudinary.com/vantagecircle/image/upload/v1729577010/VantageFit/2024/gcw/Group_337.svg"
                                        alt="Download the app"
                                        width="64"
                                        height="65"
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-11 pt-2">
                                <h3 className="font-weight-bold text-center text-lg-left py-2">
                                    User Registration and Bulk Upload Process
                                </h3>
                                <p className="para text-center text-lg-left">
                                    Once we receive the team details, we will
                                    initiate a process of bulk upload for the
                                    users. After the users are registered from
                                    our end, they will receive a mail along with
                                    the login credentials.
                                </p>
                            </div>
                        </div>
                        <div
                            className="dash relative row d-flex align-items-start justify-content-center py-4 py-lg-5"
                            data-aos="fade-up"
                            data-aos-once="true"
                        >
                            <div className="col-12 col-lg-1 px-0 mx-auto text-center d-flex justify-content-center justify-content-lg-end">
                                <div className="steps-icon">
                                    <img
                                        className="mb-2 mb-lg-4"
                                        src="https://res.cloudinary.com/vantagecircle/image/upload/v1727764072/VantageFit/2024/gcw/Download.svg"
                                        alt="Download the app"
                                        width="64"
                                        height="65"
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-11 pt-2">
                                <h3 className="font-weight-bold text-center text-lg-left py-2">
                                    Download the Vantage Fit app
                                </h3>
                                <p className="para text-center text-lg-left">
                                    Ask your employees to download the Vantage
                                    Fit app and login to participate in the
                                    virtual walkathon.
                                </p>
                            </div>
                        </div>
                        <div
                            className="row d-flex align-items-start justify-content-center py-4 py-lg-5"
                            data-aos="fade-up"
                            data-aos-once="true"
                        >
                            <div className="col-12 col-lg-1 px-0 mx-auto text-center d-flex justify-content-center justify-content-lg-end">
                                <div className="steps-icon">
                                    <img
                                        className="mb-2 mb-lg-4"
                                        src="https://res.cloudinary.com/vantagecircle/image/upload/v1727764073/VantageFit/2024/gcw/Participate.svg"
                                        alt="Participate"
                                        width="60"
                                        height="65"
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-11 pt-2">
                                <h3 className="font-weight-bold text-center text-lg-left py-2">
                                    Walk and Participate
                                </h3>
                                <p className="para text-center text-lg-left">
                                    Ask your team to walk anytime, from
                                    anywhere, and Vantage Fit will track your
                                    steps between 12th November and 10th
                                    December.
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* <div className="row justify-content-center align-items-center">
                        <div className="col-12 col-md-2">
                            <img
                                className="mb-2 mb-lg-4"
                                src="https://res.cloudinary.com/vantagecircle/image/upload/v1727764073/VantageFit/2024/gcw/register.svg"
                                alt="Register"
                                width="64"
                                height="65"
                            />
                            <p className="font-weight-bold mb-lg-0">
                                Register
                            </p>
                        </div>
                        <div className="col-12 col-md-1 px-0">
                            <p className="gcwsep" style={{"color": "#29294C57"}}> --------- </p>
                        </div>
                        <div className="col-12 col-md-2">
                            <img
                                className="mb-2 mb-lg-4"
                                src="https://res.cloudinary.com/vantagecircle/image/upload/v1727764073/VantageFit/2024/gcw/Form_team.svg"
                                alt="Form Your Team"
                                width="64"
                                height="65"
                            />
                            <p className="font-weight-bold mb-lg-0">
                                Form Your Team
                            </p>
                        </div>
                        <div className="col-12 col-md-1 px-0">

                            <p className="gcwsep" style={{"color": "#29294C57"}}> --------- </p>
                        </div>
                        <div className="col-12 col-md-2">
                            <img
                                className="mb-2 mb-lg-4"
                                src="https://res.cloudinary.com/vantagecircle/image/upload/v1727764072/VantageFit/2024/gcw/Download.svg"
                                alt="Download the app"
                                width="64"
                                height="65"
                            />
                            <p className="font-weight-bold mb-lg-0">
                                Download the App
                            </p>
                        </div>
                        <div className="col-12 col-md-1 px-0">
                            <p className="gcwsep" style={{"color": "#29294C57"}}> --------- </p>
                        </div>
                        <div className="col-12 col-md-2">
                            <img
                                className="mb-2 mb-lg-4"
                                src="https://res.cloudinary.com/vantagecircle/image/upload/v1727764073/VantageFit/2024/gcw/Participate.svg"
                                alt="Participate"
                                width="60"
                                height="65"
                            />
                            <p className="font-weight-bold mb-lg-0">
                                Participate
                            </p>
                        </div>
                    </div> */}
                </div>
                <div className="container custom_container">
                    <div className="col-12 logo-gcw-cont">
                        <div>
                            <h2 className="section-heading section-heading-top text-center no-br mb-5 mt-0">
                                Our Past Participants
                            </h2>
                            <div className="d-flex justify-content-center gcwstrip_logos"></div>
                        </div>
                        <div>
                            <h2 className="section-heading section-heading-top text-center no-br mb-5">
                                Our Wellness Partners
                            </h2>
                            <div className="d-flex justify-content-center gcwstrip_partners"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="position-relative">
                <div className="col-12 mx-auto my-5 pb-5 pt-5">
                    <h2 className="section-heading section-heading-top text-center no-br mb-5 mt-0">
                        In the News
                    </h2>
                    <div className="col-12 mx-auto relative gcwCarousel mb-5">
                        <GCWcarousel />
                    </div>
                </div>
            </section>
            <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
                <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                    <div className="col-12">
                        <h2 className="section-heading text-center no-br">
                            Unlock the power of a happier <br />& healthier
                            workforce
                        </h2>
                        {/* <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                            <a
                                href="#gcwHubspotForm"
                                className="vfitcompanycta arrowbtn-img"
                            >
                                Register Now
                            </a>
                        </div> */}
                    </div>
                </div>
            </section>
        </>
    );
};

export default GlobalWalkathonCampaign;
